import {Link} from 'react-router'

import {getCrossProductLinks} from '@core/products/cross-links'
import {ToileMark} from '@product/toile/components/ToileMark'
import {toileConfig} from '@product/toile/config'
import {livePacks} from '@product/toile/packs/registry'
import styles from './Footer.module.scss'

const siblingProducts = getCrossProductLinks('toile')

// Four columns, structure fixed by the house — brand / Make / Trust / Company (same shape as narcis and
// ovid). "Make" surfaces a few live packs plus the doors to the pack hub and the free tools; the full
// pack list stays behind /packs, same reasoning narcis and ovid already retired their own per-pack
// footer lists for.
const FEATURED_MAKE = livePacks.slice(0, 4)

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.topRow}>
                <div className={styles.brandCol}>
                    <Link to="/" className={styles.brandLink}>
                        <ToileMark size={20} />
                        <span className={styles.domain}>
                            toile<span className={styles.tld}>.pictures</span>
                        </span>
                    </Link>
                    <p className={styles.tagline}>Image generation you twist — from a preset, or from nothing.</p>
                    <div className={styles.statusRow}>
                        <span className={styles.statusDot} aria-hidden="true" />
                        <span className={styles.statusLabel}>all systems rendering</span>
                    </div>
                </div>

                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Make</span>
                    {FEATURED_MAKE.map((pack) => (
                        <Link key={pack.slug} to={`/${pack.slug}`} className={styles.link}>
                            {pack.name}
                        </Link>
                    ))}
                    <Link to="/packs" className={styles.link}>
                        All packs &rarr;
                    </Link>
                    <Link to="/tools" className={styles.link}>
                        Free tools &rarr;
                    </Link>
                </div>

                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Trust</span>
                    <Link to="/terms" className={styles.link}>Terms</Link>
                    <Link to="/privacy" className={styles.link}>Privacy</Link>
                </div>

                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Company</span>
                    <a href={`mailto:${toileConfig.contact.email}`} className={styles.link}>Contact</a>
                    {siblingProducts.map((p) => (
                        <a
                            key={p.id}
                            href={p.url}
                            target="_blank"
                            rel="noopener"
                            className={styles.link}
                        >
                            {p.name}
                        </a>
                    ))}
                </div>
            </div>

            <div className={styles.separator} aria-hidden="true" />

            <div className={styles.bottomRow}>
                <span className={styles.copyright}>&copy; 2026 toile.pictures</span>
            </div>
        </footer>
    )
}

export {Footer}
